// functions/Fx_ScheduleJobSeriesQueries.ts

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { FB_COLLECTION_PATH } from "./postActionTypes";

// Fetch most recent series start time
export const getLastSeriesStart = async (
  profileUserId: string,
  seriesId: string
): Promise<string | null> => {
  const q = query(
    collection(db, FB_COLLECTION_PATH.JobsDocs),
    where("jobInfo.core.seriesId", "==", seriesId),
    where("docStamp.userInfoFrom.uid", "==", profileUserId),
    where("docStamp.userInfoTo.uid", "==", profileUserId),
    orderBy("jobInfo.core.dateTimeStart", "desc"),
    limit(1)
  );

  const snap = await getDocs(q);
  if (snap.empty) return null;

  const data = snap.docs[0].data() as any;
  const start = data?.jobInfo?.core?.dateTimeStart;
  return typeof start === "string" && start.length > 0 ? start : null;
};

// Fetch max series index (v1.5-safe)
export const getMaxSeriesIndex = async (
  profileUserId: string,
  seriesId: string
): Promise<number> => {
  try {
    // Preferred path (requires Firestore composite index)
    const q1 = query(
      collection(db, FB_COLLECTION_PATH.JobsDocs),
      where("jobInfo.core.seriesId", "==", seriesId),
      where("docStamp.userInfoFrom.uid", "==", profileUserId),
      where("docStamp.userInfoTo.uid", "==", profileUserId),
      orderBy("jobInfo.core.seriesIndex", "desc"),
      limit(1)
    );

    const snap1 = await getDocs(q1);
    if (snap1.empty) return 0;

    const data = snap1.docs[0].data() as any;
    const idx = data?.jobInfo?.core?.seriesIndex;
    return Number.isFinite(idx) ? Number(idx) : 0;
  } catch (err) {
    // Fallback: count docs in series (slower but safe)
    try {
      const q2 = query(
        collection(db, FB_COLLECTION_PATH.JobsDocs),
        where("jobInfo.core.seriesId", "==", seriesId),
        where("docStamp.userInfoFrom.uid", "==", profileUserId),
        where("docStamp.userInfoTo.uid", "==", profileUserId)
      );

      const snap2 = await getDocs(q2);
      return snap2.size || 0;
    } catch {
      return 0;
    }
  }
};
